import Button from 'components/Button';
import View from 'components/View';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import { useTranslation } from 'next-i18next';
import { Crisp } from 'crisp-sdk-web';
import * as React from 'react';

const ContactCrispSection: React.FC = () => {
  const { t } = useTranslation();

  const handleOpenCrispChat = () => {
    Crisp.chat.open();
  };

  return (
    <div className="ContactCrispSection bg-neutral-900 py-24 sm:py-32 px-6 sm:px-0">
      <View className="px-6 sm:px-16 py-[30px] sm:py-20 bg-white rounded-3xl text-center">
        <Heading>{t('contact.needSupport')}</Heading>
        <Paragraph className="mt-1 sm:mt-4">{t('contact.chatWithOutSupport')}</Paragraph>
        <Button className="mt-6 sm:mt-8" variant="secondary" onClick={handleOpenCrispChat}>
          {t('contact.chatWithUs')}
        </Button>
      </View>
    </div>
  );
};

export default ContactCrispSection;
